import * as _ from 'lodash';
import { useEffect, useState, Fragment } from 'react';
import { useSelector, useDispatch } from "react-redux";

 
import { DataGrid, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';
import { Button, FormControl, FormGroup, TextField, Select, MenuItem, InputLabel, Box, NativeSelect, IconButton, Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions, Card, CardContent, Typography, CardActions } from "@mui/material";
import { CreateIcon, DeleteIcon, AddIcon, } from '@mui/icons-material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

const LicitacionesCat = () => {

    // const dispatch = useDispatch();
    // const updateIngresos = () => { dispatch(getUsuarios()); };
    // useEffect(updateIngresos, []);

    // const { fetching, usuarios, error, message } = useSelector(state => state.usuarios);
    // const { fetchingIngresos, ingresos, errorIngresos, messageIngresos } = useSelector(state => state.ingresos);

    // ---------------------  Components ----------------------------


    return (
        <Typography  component="div" sx={{ minWidth: 275, margin: '10px' }}>
            Lo sentimos, por el momento no hay ninguna licitación disponible...
        </Typography>
    )
}

export default LicitacionesCat